import { AnimatePresence, motion } from "framer-motion";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { NavLink } from "react-router-dom";

const Sidebar = forwardRef(
  (
    {
      commerceMenu,
      setCommerceMenu,
      financialMenu,
      setFinancialMenu,
      VolunteerMenu,
      setVolunteerMenu,
      BusinessMenu,
      setBusinessMenu,
      currentDropdown,
      currentText,
      currentBG,
      setCurrent,
    },
    ref
  ) => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [active, setActive] = useState({});

    useImperativeHandle(ref, () => {
      return {
        toggleMenu: () => setOpenSidebar(!openSidebar),
        closeTrigger: () => setOpenSidebar(false),
      };
    });
    return (
      <AnimatePresence>
        {openSidebar && (
          <motion.div
            initial={{
              x: 135,
            }}
            animate={{
              x: 0,
              transition: {
                duration: 0.2,
                ease: "easeInOut",
              },
            }}
            exit={{
              x: 135,
              transition: {
                duration: 0.2,
                ease: "easeInOut",
              },
            }}
            className="fixed right-0 top-[56px] z-10 min-h-[calc(100vh-56px)] w-fit"
            style={{
              backgroundColor: currentBG,
              color: currentText,
              boxShadow: `5px 5px 20px -5px ${currentDropdown}`,
            }}
          >
            <ul className="mt-4 font-medium">
              <li>
                <NavLink
                  to="/"
                  className="block p-2"
                  onClick={() => {
                    setActive({ home: true });
                    setOpenSidebar(false);
                    setFinancialMenu(false);
                    setCommerceMenu(false);
                    setVolunteerMenu(false);
                    setBusinessMenu(false);
                  }}
                  style={{
                    textDecorationLine: active.home ? "underline" : "none",
                  }}
                >
                  Home
                </NavLink>
              </li>
              <li className="relative">
                <button
                  className="flex w-full items-center justify-between p-2 font-medium"
                  onClick={() => {
                    setCommerceMenu(!commerceMenu);
                    setVolunteerMenu(false);
                    setBusinessMenu(false);
                    setFinancialMenu(false);
                  }}
                >
                  E-Commerce{" "}
                  <svg
                    aria-hidden="true"
                    className={`ml-1 h-5 w-5 ${
                      commerceMenu ? "rotate-180" : "rotate-0"
                    } transition-all delay-200 md:h-4 md:w-4`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                <AnimatePresence>
                  {commerceMenu && (
                    <motion.div
                      initial={{
                        height: 0,
                      }}
                      animate={{
                        height: "auto",
                        transition: {
                          duration: 0.3,
                          ease: "easeInOut",
                        },
                      }}
                      exit={{
                        height: 0,
                        transition: {
                          duration: 0.3,
                          ease: "easeInOut",
                        },
                      }}
                      className="z-10 overflow-hidden text-sm"
                      style={{ backgroundColor: currentDropdown }}
                    >
                      <div className="p-4">
                        <ul className="space-y-4">
                          <li>
                            <NavLink
                              to="/commerce/esper"
                              onClick={() => {
                                setActive({ esper: true });
                                setOpenSidebar(false);
                              }}
                              style={{
                                textDecorationLine: active.esper
                                  ? "underline"
                                  : "none",
                              }}
                            >
                              ESPER Honey
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4">
                        <ul className="space-y-4">
                          <li>
                            <NavLink
                              to="/commerce/tipsy"
                              onClick={() => {
                                setActive({ tipsy: true });
                                setOpenSidebar(false);
                              }}
                              style={{
                                textDecorationLine: active.tipsy
                                  ? "underline"
                                  : "none",
                              }}
                            >
                              Tipsy Monkey
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4">
                        <ul className="space-y-4"></ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
              <li className="relative">
                <button
                  className="flex w-full items-center justify-between p-2 font-medium"
                  onClick={() => {
                    setFinancialMenu(!financialMenu);
                    setCommerceMenu(false);
                    setVolunteerMenu(false);
                    setBusinessMenu(false);
                  }}
                >
                  Financial App{" "}
                  <svg
                    aria-hidden="true"
                    className={`ml-1 h-5 w-5 ${
                      financialMenu ? "rotate-180" : "rotate-0"
                    } transition-all delay-200 md:h-4 md:w-4`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                <AnimatePresence>
                  {financialMenu && (
                    <motion.div
                      initial={{
                        height: 0,
                      }}
                      animate={{
                        height: "auto",
                        transition: {
                          duration: 0.3,
                          ease: "easeInOut",
                        },
                      }}
                      exit={{
                        height: 0,
                        transition: {
                          duration: 0.3,
                          ease: "easeInOut",
                        },
                      }}
                      className="z-10 overflow-hidden text-sm"
                      style={{ backgroundColor: currentDropdown }}
                    >
                      <div className="p-4">
                        <ul className="space-y-4">
                          <li>
                            <NavLink
                              to="/soon"
                              onClick={() => {
                                setActive({ mars: true });
                                setOpenSidebar(false);
                                localStorage.setItem("current", "financial");
                                setCurrent("financial");
                              }}
                              style={{
                                textDecorationLine: active.mars
                                  ? "underline"
                                  : "none",
                              }}
                            >
                              Financial Mars
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4">
                        <ul className="space-y-4">
                          <li>
                            <NavLink
                              to="/soon"
                              onClick={() => {
                                setActive({ my_financial: true });
                                setOpenSidebar(false);
                                localStorage.setItem("current", "financial");
                                setCurrent("financial");
                              }}
                              style={{
                                textDecorationLine: active.my_financial
                                  ? "underline"
                                  : "none",
                              }}
                            >
                              MyFinancial
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4">
                        <ul className="space-y-4">
                          <li>
                            <NavLink
                              to="/soon"
                              onClick={() => {
                                setActive({ mcm_finance: true });
                                setOpenSidebar(false);
                                localStorage.setItem("current", "financial");
                                setCurrent("financial");
                              }}
                              style={{
                                textDecorationLine: active.mcm_finance
                                  ? "underline"
                                  : "none",
                              }}
                            >
                              MCM Finance
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
              <li className="relative">
                <button
                  className="flex w-full items-center justify-between p-2 font-medium"
                  onClick={() => {
                    setBusinessMenu(!BusinessMenu);
                    setVolunteerMenu(false);
                    setFinancialMenu(false);
                    setCommerceMenu(false);
                  }}
                >
                  Business{" "}
                  <svg
                    aria-hidden="true"
                    className={`ml-1 h-5 w-5 ${
                      BusinessMenu ? "rotate-180" : "rotate-0"
                    } transition-all delay-200 md:h-4 md:w-4`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                <AnimatePresence>
                  {BusinessMenu && (
                    <motion.div
                      initial={{
                        height: 0,
                      }}
                      animate={{
                        height: "auto",
                        transition: {
                          duration: 0.3,
                          ease: "easeInOut",
                        },
                      }}
                      exit={{
                        height: 0,
                        transition: {
                          duration: 0.3,
                          ease: "easeInOut",
                        },
                      }}
                      className="z-10 overflow-hidden text-sm"
                      style={{ backgroundColor: currentDropdown }}
                    >
                      <div className="p-4">
                        <ul className="space-y-4">
                          <li>
                            <NavLink
                              to="/business/mad_gamers"
                              onClick={() => {
                                setActive({ mad_gamers: true });
                                setOpenSidebar(false);
                              }}
                              style={{
                                textDecorationLine: active.mad_gamers
                                  ? "underline"
                                  : "none",
                              }}
                            >
                              Mad Gamers
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4">
                        <ul className="space-y-4">
                          <li>
                            <NavLink
                              to="/business/yarn_heaven"
                              onClick={() => {
                                setActive({ yarn_heaven: true });
                                setOpenSidebar(false);
                              }}
                              style={{
                                textDecorationLine: active.yarn_heaven
                                  ? "underline"
                                  : "none",
                              }}
                            >
                              Yarn Heaven
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4">
                        <ul className="space-y-4"></ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
              <li className="relative">
                <button
                  className="flex w-full items-center justify-between p-2 font-medium"
                  onClick={() => {
                    setVolunteerMenu(!VolunteerMenu);
                    setFinancialMenu(false);
                    setCommerceMenu(false);
                    setBusinessMenu(false);
                  }}
                >
                  Volunteer{" "}
                  <svg
                    aria-hidden="true"
                    className={`ml-1 h-5 w-5 ${
                      VolunteerMenu ? "rotate-180" : "rotate-0"
                    } transition-all delay-200 md:h-4 md:w-4`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                <AnimatePresence>
                  {VolunteerMenu && (
                    <motion.div
                      initial={{
                        height: 0,
                      }}
                      animate={{
                        height: "auto",
                        transition: {
                          duration: 0.3,
                          ease: "easeInOut",
                        },
                      }}
                      exit={{
                        height: 0,
                        transition: {
                          duration: 0.3,
                          ease: "easeInOut",
                        },
                      }}
                      className="z-10 overflow-hidden text-sm"
                      style={{ backgroundColor: currentDropdown }}
                    >
                      <div className="p-4">
                        <ul className="space-y-4">
                          <li>
                            <NavLink
                              to="/soon"
                              onClick={() => {
                                setActive({ volunteer: true });
                                setOpenSidebar(false);
                              }}
                              style={{
                                textDecorationLine: active.volunteer
                                  ? "underline"
                                  : "none",
                              }}
                            >
                              Volunteer
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4">
                        <ul className="space-y-4"></ul>
                      </div>
                      <div className="p-4">
                        <ul className="space-y-4"></ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className="block p-2"
                  onClick={() => {
                    setActive({ contact: true });
                    setOpenSidebar(false);
                    setFinancialMenu(false);
                    setCommerceMenu(false);
                    setVolunteerMenu(false);
                    setBusinessMenu(false);
                  }}
                  style={{
                    textDecorationLine: active.contact ? "underline" : "none",
                  }}
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }
);

export default Sidebar;
